import React from "react";
import styled from "styled-components";
import { color } from "../templates/ui";

const StyledMenuItem = styled.li`
  &:hover {
    > a {
      color: ${props => {
        if (props.isFooterLink) {
          return `${color.body.base}`;
        }
        if (props.isOffCanvasMenu) {
          return `${color.black.base}`;
        }

        return `${color.primary.base}`;
      }};
      background-color: ${props => (props.isFooterLink || props.isOffCanvasMenu ? "rgba(0,0,0,.1)" : "transparent")};

      &:before {
        transform: none;
      }
    }

    ul {
      display: block;
    }
  }
`;

const MenuItem = ({ className, children, isFooterLink, isMainMenuLink, isOffCanvasMenu }) => (
  <StyledMenuItem className={className} isFooterLink={isFooterLink} isOffCanvasMenu={isOffCanvasMenu}>
    {children}
  </StyledMenuItem>
);

export default MenuItem;
